<template>
  <div>
    <div class="phone-class-list" :class="{'mobile-course-list':isMobile}">
      <!--            <a-row :gutter="{ xs: 8, sm: 8, md: 16, lg: 16 }">-->
      <a-row :gutter="{ xs: 16, sm: 16, md: 16, lg: 16 }">
        <header>
          <img class="title-icon" :src="iconList[classType]" alt="">
          <span class="title-course">{{ title }}</span>
          <img @click="jump" v-if="classType != 'free'" class="vip-free" src="@assets/img/index/vip-free.png" alt="">
          <span class="more-course"> <router-link :to="{path:'other/search',query:{type:classType}}">
                    更多 <a-icon type="right-circle"/></router-link> </span>
        </header>
        <div style="padding: 20px" v-if="!isLoading && courseList.length === 0 ">
          <a-empty description="暂无数据..."/>
        </div>
        <ul v-if="isLoading">
          <li class="col" v-for="item in pageSize " :key="item">
            <!--<a-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">-->
              <spin class="spin"/>
          </li>
        </ul>
        <ul>
          <li class="col" v-for="item in courseList " :key="item.courseId">
            <!--<a-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="col">-->
              <CourseListItem :course-info="item"/>
          </li>
        </ul>
      </a-row>
    </div>
  </div>
</template>

<script>
import {courseTypeList} from "@api/course-api"
import CourseListItem from '@components/course/CourseListItem'
import spin from "../loading/Spin"
import common from "../../mixin/common";
import {SUCCESS} from "@constants/code";
import {showError} from "@utils/msg";
import freeIcon from '@assets/img/index/free-icon.png'
import discountIcon from '@assets/img/index/time-limit-icon.png'
import boutiqueIcon from '@assets/img/index/boutique-icon.png'
import {isJumpMemberPage} from "@utils/common";
export default {
  name: "",
  components: {
    CourseListItem, spin
  },
  mixins: [common],
  data() {
    return {
      isLoading: true,
      // pageSize: 10,
      courseList: [],
      iconList:{
        free:freeIcon,
        boutique:boutiqueIcon,
        discount:discountIcon
      },
    }
  },
  props: {
    title: {
      type: [String],
      default: "标题"
    },
    classType: {
      type: [String],
      default: "free"
    },
    pageSize: {
      type: [String],
      default: "5"
    },
  },
  created() {
    // this.pageSize = this.listNumber
    this.isLoading = true;
    if (this.isMobile) {
      // 移动端展示6个
      this.pageSize = 6;
    }
    courseTypeList(this.classType, 1, this.pageSize).then((res) => {
      if (res.code === SUCCESS) {
        this.courseList = res.rows;
      } else {
        showError("课程列表错误", res.msg);
      }
      this.isLoading = false;
    });
  },
  methods: {
    jump(){
      isJumpMemberPage()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../styles/course.less";
.title-icon{
  width:38px !important;
  margin-right: 15px;
}
.spin {
  margin: 20px 0;
}

.phone-class-list {
  width: 1160px;
  background: #fff;
  padding: 30px 20px;
  margin: 15px auto 0;
  border-radius: 20px;

  header {
    display: flex;
    align-items: center;
    font-size: 24px;
    padding: 0 12px 10px 0;
    border-bottom: 2px solid #e8e8e8;
    .title-course{
      font-weight: 600;
    }
    .vip-free{
      cursor:pointer;
      margin-left: 8px;
      width: 93px;
    }
  }

  img {
    width: 100%;
  }
  ul{
    display: flex;
    flex-wrap: wrap;
  }
  ul li {
    margin-top: 14px;
  }

  .col {
    width: 19%;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.15);
    border-radius: 10px;
    float: left;
    margin: 14px 0.5% 0;
  }
}


.more-course {
  font-size: 16px;
  line-height: 34px;
  margin-left:auto;
  a {
    color: #999999;
  }
}

.more-course:hover {
  cursor: pointer;
  color: #00CF8C;
}

// 移动端样式
.mobile-course-list {
  width: 100%;
  padding: 10px 20px;
  .col {
    width: 48%;
    margin: 14px 1% 0;
  }
  .title-course{
    font-size: 18px;
    font-weight: 600;
  }
 header{
   .vip-free{
     width: 58px;
   }
 }
}

// 暂时去掉响应式布局
/*@media (max-width: 992px) {*/
/*}*/

/*@media (max-width: 576px) {*/
/*    header {*/
/*        text-align: left;*/
/*    }*/
/*}*/

/*@media (min-width: 768px) {*/
/*}*/

/*@media (min-width: 992px) {*/
/*    .phone-class-list {*/
/*        padding: 10px 20px;*/
/*    }*/
/*}*/

/*@media (min-width: 1200px) {*/
/*    .phone-class-list {*/
/*        padding: 10px 50px;*/
/*    }*/
/*}*/

/*@media (min-width: 1600px) {*/
/*    .phone-class-list {*/
/*        padding: 10px 100px;*/
/*    }*/
/*}*/


</style>
